const IconComponent = ({ class_name, children, dataToggle = null, dataTarget = null, ariaExpanded = null}) => {
  
  return <span className={class_name}
    data-bs-toggle={dataToggle}
    data-bs-target={dataTarget}
    aria-expanded={ariaExpanded}
  >{children}</span>;
};

export default IconComponent;
